// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__TwQnS","container":"about_container__kHaMc"};